
import * as commonFunction from './commonFunction'
export default {
  data () {
    return {
      height: 0,
      listHeight: 0,
      currentPath: window.location.pathname,
      isIOS: false
    }
  },
  methods: {
    calculateHeight () {
      this.$nextTick(() => {
        const mainContainerHeight = this.$refs.mainContainer.clientHeight
        if (this.currentPath === '/ClientInfo') {
          if (this.isIOS === true) {
            this.listHeight = this.height - 270
          } else {
            this.listHeight = this.height - 218
          }
        } else if (this.currentPath === '/pushList') {
          if (this.isIOS === true) {
            this.listHeight = this.height - 320
          } else {
            this.listHeight = this.height - 268
          }
        } else {
          if (this.isIOS === true) {
            this.listHeight = this.height - 270
          } else {
            this.listHeight = this.height - 218
          }
        }
      })
    }
  },

  mounted () {
    if (commonFunction.isIOS() === true) {
      this.isIOS = true
    }
    this.height = window.innerHeight
  },

  created () {
    this.calculateHeight()
  }
}
